interface WatchIntroButtonProps {
  onClick: () => void;
  /** Redacted view: drawn the same but never plays (the click is only counted). */
  locked?: boolean;
}

/** Prototype .video-btn: a white pill with a purple play disc, "Watch intro", in the middle of the cover. */
function WatchIntroButton({ onClick, locked = false }: WatchIntroButtonProps) {
  return (
    <button
      type="button"
      className={`watch-intro${locked ? " watch-intro--locked" : ""}`}
      onClick={onClick}
      aria-disabled={locked || undefined}
    >
      <span className="watch-intro__play" aria-hidden>
        <svg viewBox="0 0 24 24">
          <path d="M6 4v16l14-8z" />
        </svg>
      </span>
      Watch intro
    </button>
  );
}

export default WatchIntroButton;
